module.exports = __webpack_public_path__ + "DINNextLTPro-LightItalic.woff2?3d579a292a06e3bce8790d1868c55881";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-LightItalic.woff2
// module id = 1430
// module chunks = 0